import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-form-control-error',
    templateUrl: './form-control-error.component.html',
    styleUrls: ['./form-control-error.component.less']
})
export class FormControlErroComponent {
    @Input() msgError: string;
}
